<script setup lang="ts">
import { advent24RoundUsers } from '~/lib/dates'

const router = useRouter()

const items = computed(() => {
  const entries = Object.entries(advent24RoundUsers)

  return [entries.map(nu => ({
    label: nu[1],
    shortcuts: [nu[0]],
    click: () => router.push(`/reveal/${nu[0]}`),
  }))]
})
</script>

<template>
  <div>
    <!-- <NavBar /> -->
    <div class="flex bg-zinc-900 justify-start text-zinc-content border-zinc-800 border-b-2 p-2 mb-2">
      <div class="flex-initial mr-2">
        <NuxtLink to="/">
          <img
            src="/wordmark.svg"
            alt="Retskaffen"
            class="h-10"
          >
        </NuxtLink>
      </div>
      <div class="flex-initial">
        <UButton
          to="/highscores"
          variant="ghost"
          size="xl"
          icon="i-lucide-trophy"
        >
          Ranglisten
        </UButton>
      </div>
      <div class="flex-initial">
        <UDropdown
          :items
          label="Reveals"
        >
          <UButton
            label="Reveals"
            variant="ghost"
            size="xl"
            trailing-icon="i-heroicons-chevron-down-20-solid"
          />
        </UDropdown>
      </div>
    </div>
    <UContainer>
      <slot />
    </UContainer>
  </div>
</template>
